<template>

<div class="container">
    <SideMenuComponent :isVisible="menuVisible" @toggleMenu="handleToggleMenu"/>


  <div class="content-layout">

    <!-- Mobile Header with hamburger, logo, theme toggle -->
    <MobileHeaderComponent
      v-if="isMobile && configData.site_caption"
      @toggleMenu="handleToggleMenu"
    />

    <!-- Desktop Header (hidden on mobile) -->
    <header class="" v-if="!showHeader && configData.site_caption && !isMobile">
      <HeaderChatbotsComponent />
    </header>


      <main>
        

      <router-view v-slot="{ Component }">
        <keep-alive>
          <component :is="Component" :key="$route.fullPath"></component>
        </keep-alive>
      </router-view>

        <!-- <router-view></router-view> -->
        <button 
          v-if="buttonVisible" 
          @click="isModalVisible = true" 
          class="btn btn-danger"
          :style="{ position: 'absolute', top: buttonPosition.top, left: buttonPosition.left }"
        >
          Сообщить об ошибке
        </button>    
      </main>


    <!-- Footer moved to SideMenuComponent -->
    <ErrorModalComponent 
      :selectedText="selectedText" 
      :show="isModalVisible" 
      @close="isModalVisible = false"
    />
    <!-- V2T-42 · M2: открывается из бокового меню ClipCut; здесь, чтобы не гаснуть со сворачиванием меню -->
    <WhatsNewModal />
  </div>
</div>

</template>



<script>
import SideMenuComponent from './components/SideMenuComponent.vue';
// import HeaderComponent from './components/HeaderComponent.vue';
import HeaderChatbotsComponent from './components/HeaderChatbotsComponent.vue';
import MobileHeaderComponent from './components/MobileHeaderComponent.vue';
import ErrorModalComponent from './components/ErrorModalComponent.vue'; // Импортируйте ваш компонент
import WhatsNewModal from './components/WhatsNewModal.vue';
import 'quill/dist/quill.snow.css';


// FooterComponent moved to SideMenuComponent


import { mapActions, mapGetters, useStore} from 'vuex';
import { computed, onMounted, nextTick } from 'vue';



export default {
  name: 'App',
  components: {
    // HeaderComponent,
    SideMenuComponent,
    HeaderChatbotsComponent,
    MobileHeaderComponent,
    ErrorModalComponent,
    WhatsNewModal
  },
  watch: {
    $route: {
        immediate: true,
        // eslint-disable-next-line
        handler(to, from) { 
            document.title = to.meta.title || '...';
        }
    },
  },
  data() {
    return {
      videoTitle: '',
      textGenerated: '',
      showTest: true,
      showTimecodes: false,
      appMounted: false,
      showHeader: true,
      previewMode: false,
      selectedText: '',
      isModalVisible: false,
      buttonPosition: { top: '0px', left: '0px' },
      buttonVisible: false,

    };
  },
  created() {
    const urlParams = new URLSearchParams(window.location.search);
    const hash = urlParams.get('hash');
    const preview = urlParams.get('preview'); // Добавлено получение параметра preview
    const chatbot_name = urlParams.get('chatbot_name'); // Добавлено получение параметра preview
    const login_token = urlParams.get('login_token');

    if (login_token) {
      localStorage.setItem('authToken', login_token);
      this.store.dispatch('user/checkUser');

      // Clean up URL
      urlParams.delete('login_token');
      const queryString = urlParams.toString();
      const newUrl = window.location.origin + window.location.pathname + (queryString ? '?' + queryString : '');
      window.history.replaceState({}, document.title, newUrl);
    }

    // Quick Auth Links - обработка action параметра
    // @see docs/features/QUICK_AUTH_LINKS.md
    const action = urlParams.get('action');
    if (action) {
      // Сохраняем action в store для последующей обработки
      this.store.dispatch('app/setPendingAction', action);

      // Убираем action из URL
      urlParams.delete('action');
      const cleanQueryString = urlParams.toString();
      const cleanUrl = window.location.origin + window.location.pathname +
          (cleanQueryString ? '?' + cleanQueryString : '');
      window.history.replaceState({}, document.title, cleanUrl);
    }

    console.log(hash);
    console.log(preview);
    this.updateHash(hash); // Dispatch the updateHash action
    
    // Если параметр preview равен 'article', то скрыть header и footer
    if (preview) {
        this.showHeaderFooter(false);
        this.enablePreview(preview);
    }    
    if (chatbot_name){
      this.setChatbotName(chatbot_name);
    }
  },
  methods: {
    ...mapActions('hash', ['updateHash']), // Map the updateHash action
    ...mapActions('app', ['setPreview', 'setChatbotName', 'setIsMobile', 'setIsTablet', 'toggleMenuVisible', 'setMenuVisible']),
 
    handleToggleMenu() {
      this.toggleMenuVisible();

    }, 

    enablePreview(type) {
      this.setPreview(type);
    },    
    showHeaderFooter(show) {
        this.showHeader = show;
    },
    handleTextSelection(event) {
      // Функционал сообщения об ошибке работает только для harikatha
      if (this.chatbotName !== 'harikatha') {
        return;
      }

      // Проверяем, что клик был сделан внутри .article-container
      if (!event.target.closest('.article-container')) {
        return; // Если клик вне контейнера, выходим из функции
      }

      // Если клик был сделан по кнопке, выходим из функции
      if (event.target.tagName === 'BUTTON' || event.target.closest('button')) {
        return;
      }

      const selection = window.getSelection();

      // Проверяем, что выделение непустое и содержит хотя бы один диапазон
      if (selection.rangeCount > 0) {
        const selectedText = selection.toString();

        if (selectedText) {
          const range = selection.getRangeAt(0);
          const rect = range.getBoundingClientRect();

          this.selectedText = selectedText;

          // Позиционируем кнопку в зависимости от выделенного текста
          this.buttonPosition = {
            top: `${rect.bottom + window.scrollY}px`, // позиция сверху
            left: `${rect.left + window.scrollX}px`, // позиция слева
          };
          this.buttonVisible = true; 
        } else {
          this.buttonVisible = false;
        }
      } else {
        this.buttonVisible = false; 
      }
    },

    updateBodyClasses() {
      const width = window.innerWidth;
      const body = document.body;
      console.log('updateBodyClasses');
      // Удаляем все предыдущие классы
      body.classList.remove('isMobile', 'isMobileTablet');

      // Добавляем класс в зависимости от ширины экрана
      if (width <= 768) {
        body.classList.add('isMobile');
        this.isMobileView = true;
        this.isTabletView = false;
      } else if (width <= 1024) {
        body.classList.add('isMobileTablet');
        body.classList.add('isMobile');
        this.isMobileView = true;
        this.isTabletView = true;
      } else {
        this.isMobileView = false;
        this.isTabletView = false;
      }


      // console.log('setIsMobile');
      this.setIsMobile(this.isMobileView); 
      this.setIsTablet(this.isTabletView); 
    }    
    
  },
  computed: {
    ...mapGetters('app', ['isMobile', 'isPreview', 'chatbotName', 'configData', 'menuVisible']), 
    ...mapGetters('hash', ['getHash']), // Map the getHash getter
    ...mapGetters("article", ["getArticleItem"]),
    articleItem: {
      get() {
        return this.getArticleItem || {};
      },
      set(value) {
        this.updateArticleItem(value);
      },
    },
  },

  beforeUnmount() {
    document.removeEventListener('mouseup', this.handleTextSelection);  
    window.removeEventListener('resize', this.updateBodyClasses);

  },

  mounted() {
    this.appMounted = true;

    nextTick(() => {
      if (this.isMobile){
        this.setMenuVisible(false); 
      } else{
        this.setMenuVisible(true); 
      }
    });
    // Добавляем классы при загрузке компонента
    this.updateBodyClasses();



    window.addEventListener('resize', this.updateBodyClasses);

    document.addEventListener('mouseup', this.handleTextSelection);
    // Вставка скрипта Telegram Web Apps при монтировании
    // 2026-09-04: SDK грузился ТОЛЬКО с telegram.org и БЕЗ обработчика onerror —
    // сбой был полностью тихим. Внутри Mini App это тупик: без SDK нет initData,
    // значит нет автовхода, а адресной строки, чтобы уйти в обычный браузер, там тоже
    // нет. В России telegram.org у мобильных операторов режут жёстче, чем в ДЦ.
    // Порядок намеренно такой: сперва официальный источник (всегда актуальная версия),
    // и только если он не поднялся — своя копия из public/vendor. Обратный порядок
    // означал бы, что все сидят на нашем слепке и он тихо протухает.
    const onSdkReady = () => {
      // Скрипт может «загрузиться» и не быть SDK: перехват провайдера, заглушка,
      // страница-капкан оператора — всё это отдаёт 200 и дёргает onload. Без проверки
      // обращение к window.Telegram.WebApp роняет обработчик молча.
      if (!window.Telegram || !window.Telegram.WebApp) {
        console.warn('Telegram SDK: скрипт загрузился, но window.Telegram.WebApp отсутствует');
        return;
      }
      var WebApp = window.Telegram.WebApp;

      console.log(WebApp);
      if (typeof WebApp.initDataUnsafe.user !== 'undefined'){
        // авторизация пользователя
        
        var user = WebApp.initDataUnsafe.user;
        user.hash = WebApp.initDataUnsafe.hash;
        user.query_id = WebApp.initDataUnsafe.query_id;
        user.auth_date = WebApp.initDataUnsafe.auth_date;
        // 2026-09-04 (SEC-EG-2 такт 2): бэку нужна СЫРАЯ строка initData.
        // Подпись Mini App считается по ней, где user — одно JSON-поле целиком;
        // из разобранного initDataUnsafe.user эту строку не собрать обратно, и
        // проверка не сходилась в принципе. Разобранный объект оставляем: по нему
        // работает существующая ветка виджета, если initData почему-то пуст.
        this.store.dispatch('user/loginUser', { user: user, initData: WebApp.initData || '' }); 
        console.log(WebApp.initDataUnsafe.user);
      }
      


      // // Обработка данных о пользователе при входе через Telegram
      // document.addEventListener('tg-external-auth', (event) => {
      //   const { user } = event.detail;
      //   // Обработайте данные о пользователе, например, отправьте на сервер
      //   console.log('Получены данные о пользователе:', user);
      // });
    };
    const loadTgSdk = (src, onFail) => {
      const el = document.createElement('script');
      el.src = src;
      el.async = true;
      el.onload = onSdkReady;
      if (onFail) el.onerror = onFail;
      document.head.appendChild(el);
    };
    loadTgSdk('https://telegram.org/js/telegram-web-app.js', () => {
      console.warn('Telegram SDK: telegram.org недоступен, беру локальную копию');
      // ⛔ Путь строго от BASE_URL: приложение живёт в подкаталоге (publicPath '/app/'),
      // и '/vendor/…' от корня домена даёт 404 — фолбэк молча не сработал бы.
      loadTgSdk(process.env.BASE_URL + 'vendor/telegram-web-app.js', () => {
        console.warn('Telegram SDK: локальная копия тоже не поднялась — автовхода не будет');
      });
    });




  },
  setup() {
    const store = useStore();

    onMounted(async () => {
      console.log('fetch config data');
      // Вызовите новое действие для загрузки конфигурационных данных
      await store.dispatch('app/fetchConfigData');
      await store.dispatch('app/initTheme');

      // Check user authentication on app load
      await store.dispatch('user/checkUser');

      const configData = store.state.app.configData;
      document.title = configData.site_caption;
      const body = document.body;
      body.classList.remove('show_sidebar');
      if (configData.show_sidebar){
         body.classList.add('show_sidebar');
      }

      // Hide loading screen after app is ready
      const loader = document.getElementById('app-loader');
      if (loader) {
        loader.classList.add('hidden');
        // Remove from DOM after transition
        setTimeout(() => loader.remove(), 300);
      }
    });

    const article = computed(() => store.getters['article/getArticleItem']);

    return {
      article,
      store
    };
  }
};
</script>

<style>
    body {
/*      font-family: 'Roboto', sans-serif;*/
/*      background: url(assets/bg-stars.svg) repeat-y;
      background-position: center 50%;
*/    
    }

    .header {
      border-top-right-radius: 0;
      border-top-left-radius: 0;
    }

    .inner {
/*      max-width: 800px;*/
    }

    #app {
      min-height: 100vh;
    }
    .tg-link {
      flex-grow: 1;
    }

    .menu a {
      margin-left: 10px;
    }

    textarea {
      border: 1px solid var(--yt-border-color, #BFBFBF);
      border-radius: 10px;
    }

    .time {
      font-weight: 600;
    }

    .relative{
      position: relative;
    }

    blockquote {
      background: var(--yt-bg-tertiary, #f1ecff);
      margin-bottom: 10px;
      padding: 20px;
      border-left: 4px solid var(--yt-primary-light, #cabeff);
    }

    .absolute-center-x {
      -webkit-transform: translateX(-50%);
      -ms-transform: translateX(-50%);
      transform: translateX(-50%);
      left: 50%;
    }
    .text-success {
      color: var(--yt-success, #339933);
    }

    .fragment-imgs {
      display: grid;
      grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
      grid-gap: 10px;
      margin: 20px 0;
    }

    .fragment-imgs img {
      width: 100%;
      height: auto;
      border-radius: 8px;
      margin-right: 5px;
    }

    h3 {
      color: var(--yt-text-primary, #444);
    }

    html[data-bs-theme="dark"] .shadow, html[data-bs-theme="dark"] .shadow-sm {
      box-shadow: none !important;
    }

    blockquote p {
      margin: 0;
    }

    .modal-xl{
      max-width: 90%;
    }

    .preview{
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
    }

    .preview body{
      min-width: 100%;
    }

    .xs{
      font-size: 0.5em;
    }
  
    .btn-outline-light-2{
      opacity:0.4
    }    

    .nowrap{
      text-wrap: nowrap;
    }
    
    .inline-block{
      display: inline-block;
    }

    .micro{
      font-size: 0.6em;
    }

    .menu-open .content-layout{ 
      margin-left: 270px;
    }

    .isMobile.menu-open .content-layout{
      margin-left: 0;
    }

    /* Block body scroll when mobile menu is open */
    .isMobile.menu-open {
      overflow: hidden;
      position: fixed;
      width: 100%;
      height: 100%;
    }    

  .input-group > :not(:first-child):not(.dropdown-menu):not(.valid-tooltip):not(.valid-feedback):not(.invalid-tooltip):not(.invalid-feedback){
    background-color: var(--bs-body-bg);
  }
.word-break{
  word-break: break-word;
}

/* Print styles - скрываем элементы при печати */
@media print {
  /* Скрываем боковое меню */
  .container > div:first-child {
    display: none !important;
  }

  /* Скрываем header */
  header {
    display: none !important;
  }

  /* Скрываем footer */
  footer {
    display: none !important;
  }

  /* Убираем отступ для контента */
  .content-layout {
    margin-left: 0 !important;
  }

  /* Скрываем кнопку ошибки */
  .btn-danger {
    display: none !important;
  }
}

</style>
